import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, retry, tap } from 'rxjs/operators'
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
// import { CustomMenu, HiddenResource } from "../models/custom-menu.interface";
// import { FullMenu } from "../models/full-menu.interface";
// import { FullUser } from "../models/full-user.interface";
// import { Rol } from "../models/roles.interface";
// import { User, UserMe } from "../models/user.interface";
import { InternalService } from "./internal.service";

@Injectable()
export class ReportsService extends InternalService {
    constructor( http: HttpClient, router: Router, authService: AuthService){
        super(http, router, authService);
    }

    ReportSender(formData: FormData): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }

        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');

        return this.http
            .post(`${environment.devApiUrl}/report/report-sender/`, formData, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
    getReportsOptions(report_name: string, company_id: string): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        let params = "?company_id=" +"604a80e6-39d2-4700-bae2-14d80adeadfb";
        if (report_name) {
            params += `report_name=${report_name}`;
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.devApiUrl}/admin-reports/get-reports-options/${params}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    getMailReportDetails(report_mail_id: string): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        let params = "?report_mail_id=" + report_mail_id;
        return this.http.get(`${environment.devApiUrl}/admin-reports/get-mail-report-details/${params}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    getUsersPerReport(dashboard_id: string, company_id, structure_filters): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        let params = "?dashboard_id=" + dashboard_id + "&company_id=" +"604a80e6-39d2-4700-bae2-14d80adeadfb";
        if (structure_filters) {
            params += "&structure_filters=" + JSON.stringify(structure_filters);
        }
        return this.http.get(`${environment.devApiUrl}/admin-reports/get-users-per-report/${params}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    postUserPerReport(data): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.devApiUrl}/admin-reports/post-user-per-report/`, data, {headers})
            .pipe(
                retry(1),
                catchError(this.handleError.bind(this))
            );
    }
    postMailReportDetails(data): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.devApiUrl}/admin-reports/post-mail-report-details/`, data, {headers})
            .pipe(
                retry(1),
                catchError(this.handleError.bind(this))
            );
    }
    postReportInitializer(report_id:string): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        let data = {
            "report_id": report_id
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.devApiUrl}/report/report-initializer/`, data, { headers })
            .pipe(
                retry(1),
                catchError(this.handleError.bind(this))
            );
    }
    getCompanyUserStructureFilters(company_id: string): Observable<any> {
        // let token = localStorage.getItem('token');
        let token = environment.devApiToken
        // if (token) {
        //     token = JSON.parse(token);
        // }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        let params = "?company_id=" +"604a80e6-39d2-4700-bae2-14d80adeadfb";
        return this.http.get(`${environment.devApiUrl}/admin-reports/get-company-user-structure-filters/${params}`, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // private handleError (error: HttpErrorResponse) {
    //     let publicPages = ['/login', '/auth/complete-registration'];
    //     const currentPage = this.router.url
    //     let currentPageValue
    //     if (this.router.url.includes('?')) {
    //         currentPageValue = currentPage.split('?')[0]
    //     }
    //     if (error.error instanceof ErrorEvent) {
    //         console.error('An error occurred:', error.error.message)
    //     } else if (publicPages.includes(currentPageValue)) {
    //         console.error('An error occurred:', error.error.message)
    //     } else {
    //         console.error(`Backend returned code ${error.status}, ` + `body was:`)
    //         console.error(error)
    //         if (error.status === 401) {
    //             this.authService.logout();
    //             this.router.navigate(['/login']);
    //         }
    //     }
    //     return throwError({
    //         message: 'Something bad happened; please try again later.',
    //         code: error.status
    //     })
    // }
}